import { QuoteStatus } from '@/api/apis/case';

export const dangerQuoteStatuses = [QuoteStatus.Rejected, QuoteStatus.RejectedInternally, QuoteStatus.Recalled];

export const quoteStatusesToRecall = [QuoteStatus.Approved, QuoteStatus.Rejected, QuoteStatus.SentToTXCenter];

export const quoteCreatedStatuses = [
  QuoteStatus.ApprovedInternally,
  QuoteStatus.SentToTXCenter,
  QuoteStatus.Approved,
  QuoteStatus.Rejected,
];
